var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.0429688C4.06 0.0429688 0.0416679 4.06214 0.0416679 9.0013C0.0416679 13.9405 4.06 17.9596 9 17.9596C13.94 17.9596 17.9583 13.9405 17.9583 9.0013C17.9583 4.06214 13.94 0.0429688 9 0.0429688ZM9 16.7096C4.74917 16.7096 1.29167 13.2521 1.29167 9.0013C1.29167 4.75047 4.74917 1.29297 9 1.29297C13.2508 1.29297 16.7083 4.75047 16.7083 9.0013C16.7083 13.2521 13.2508 16.7096 9 16.7096ZM12.5417 9.0013C12.5417 9.3463 12.2617 9.6263 11.9167 9.6263H6.08333C5.73833 9.6263 5.45833 9.3463 5.45833 9.0013C5.45833 8.6563 5.73833 8.3763 6.08333 8.3763H11.9167C12.2617 8.3763 12.5417 8.6563 12.5417 9.0013Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.ca92a99f4f07d85f254ac5baa9ec7ac0.svg";
export { ForwardRef as ReactComponent };